namespace RioERP.Carts {
    export interface CartRow {
        Id?: number;
        Name?: string;
        FranchiseeId?: number;
        CustomerId?: number;
        FranchiseeName?: string;
        SourceOrderNumber?: string;
        CustomerName?: string;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingStateId?: number;
        ShippingPincode?: number;
        EInvoiceTo?: number;
        InvoiceCompanyId?: number;
        DiscountCoupon?: string;
        DiscountAmount?: number;
        GrossAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        TaxAmount?: number;
        EFranchiseeDiscountType?: number;
        EFranchiseeDiscount?: number;
        FranchiseeDiscountValue?: number;
        FranchiseeDiscountAmount?: number;
        CartProducts?: CartProductsRow[];
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace CartRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Carts.Cart';
        export const deletePermission = 'Carts:CartsManagement:Modify';
        export const insertPermission = 'Carts:CartsManagement:Modify';
        export const readPermission = 'Carts:CartsManagement:View';
        export const updatePermission = 'Carts:CartsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId",
            FranchiseeName = "FranchiseeName",
            SourceOrderNumber = "SourceOrderNumber",
            CustomerName = "CustomerName",
            CustomerEmail1 = "CustomerEmail1",
            CustomerEmail2 = "CustomerEmail2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingStateId = "ShippingStateId",
            ShippingPincode = "ShippingPincode",
            EInvoiceTo = "EInvoiceTo",
            InvoiceCompanyId = "InvoiceCompanyId",
            DiscountCoupon = "DiscountCoupon",
            DiscountAmount = "DiscountAmount",
            GrossAmount = "GrossAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            TaxAmount = "TaxAmount",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EFranchiseeDiscount = "EFranchiseeDiscount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            CartProducts = "CartProducts",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
